import styled from 'styled-components';

import colors from 'apps/promo/theme/colors';
import media from 'apps/promo/theme/media';
import zIndex from 'apps/promo/theme/zIndex';

const shouldForwardModalViewportProp = (prop) => !['useThemeColor'].includes(prop);
const shouldForwardModalBodyProp = (prop) => !['isVerticalCentered'].includes(prop);

export const ModalContainer = styled.div`
    background-color: ${colors.greyRgba28};
    bottom: 0;
    left: 0;
    min-width: 288px;
    position: fixed;
    right: 0;
    top: 0;
    z-index: ${zIndex.modalIndex};
`;
export const ModalViewport = styled.div.withConfig({ shouldForwardProp: shouldForwardModalViewportProp })`
    background-color: ${(props) => (props.useThemeColor ? props.theme.white : colors.white)};
    bottom: 0;
    color: ${(props) => (props.useThemeColor ? props.theme.black : colors.baseColor)};
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    position: absolute;
    right: 0;
    top: 0;
`;
export const ModalBody = styled.div.withConfig({ shouldForwardProp: shouldForwardModalBodyProp })`
    padding: 72px 24px 64px 24px;
    margin: 0 auto;
    /* content width 480 */
    max-width: 528px;
    min-height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: ${(props) => (props.isVerticalCentered ? 'center' : 'flex-start')};

    ${media.tablet720} {
        padding: 128px 24px;
        /* content width 504px */
        max-width: 552px;
    }
`;
